/**
 * File with global variables
 */
/**
 * @type {FormData|null}
 */
let additionalFormData = null



export function getAdditionalFormData() {
  return additionalFormData
}
/**
 * 
 * @param {FormData|null} data 
 */
export function setAdditionalFormData(data) {
  additionalFormData = data
}
export function clearAdditionalFormData() {
  additionalFormData = null
}